/**
 * RubyのString#lengthメソッドに挙動を合わせた文字数カウント用メソッド
 * NOTE: String#lengthメソッドはruby-grapeのmax_lengthのバリデーション等で使用されている
 */
export const getRubyStringLength = (str: string): number => {
  return [...str].length;
};
